import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface BrandEditorViewProps {
    brandRequest: DropdownRequest<BrandSummary>;
    value: number | null;
    mode: ControlMode;
    onChanged: (number: BrandSummary | null) => void;
    label?: string;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
    required?: boolean;
	idAgent?: number;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

export class BrandEditorView extends React.Component<BrandEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Brand';
        }
        return (
            <DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				disabled={this.props.mode == 'display'}
				model={this.props.value}
				onChanged={(item) => { this.props.onChanged(item != null ? item : null) }}
				request={this.props.brandRequest}
				keyField='id'
				textField='name'
				required={this.props.required}
				cascadeField="idAgent"
				cascadeFiltertype="params"
				cascadeValue={this.props.idAgent}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/brands/parts/brand-editor.view.tsx